<dx-text-box #addresstext>
	<dxi-button
	name="search"
	location="after"
	[options]="{icon: 'search', type: 'normal', stylingMode: 'text', disabled: true}">
	</dxi-button>
</dx-text-box>